import Vue from 'vue'
import MyLoading from "@/components/tools/loading.vue";
import MyTitle from "@/components/customTitle/index.vue";
Vue.component("my-loading", MyLoading); //注册组件
Vue.component("my-title", MyTitle); //注册组件
import {
  Button,
  Breadcrumb,
  message,
  notification,
  Modal,
  Progress,
  Cascader,
  Spin,
  Input,
  Form,
  Select,
  Upload,
  Icon,
  FormModel,
  Dropdown,
  Menu,
  Divider,
  Radio,
  Checkbox,
  Tooltip,
  Empty,
  Badge,
  Col, Row, Table, Drawer, Pagination, DatePicker, Picker, TimePicker, ConfigProvider, Switch, Tabs, Steps, Avatar
} from 'ant-design-vue';
const components = [
  Button,
  Empty,
  Breadcrumb,
  DatePicker,
  TimePicker,
  Modal,
  Progress,
  Cascader,
  Spin,
  Input,
  Form,
  Select,
  Upload,
  Icon,
  Tooltip,
  FormModel,
  Dropdown,
  Menu,
  Divider,
  Radio,
  Checkbox,
  Col, Row,
  Table,
  Badge,
  Avatar,
  Drawer, Pagination, Switch, Tabs, Steps
]

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;
Vue.use(ConfigProvider)

components.map(component => {
  Vue.use(component);
});



// WEBPACK FOOTER //
// ./src/utils/registerComponent.js